import React from "react";




export default function Section1(props) {

    return (
        <>
            <div className="section" data-aos="fade-up"
                data-aos-duration="3000">
                <section>
                    <h2 style={{ textAlign: 'center', marginBottom: '10px' }}>A importância da preservação do meio ambiente</h2>
                    <p style={{ textAlign: 'center' }}> Preservar o meio ambiente é um ato importante não só para a humanidade.</p>
                    <hr />
                    <br />
                    <div id="image01">
                        <img style={{ marginBottom: '15px', width: '90%', height: '10%' }} src={props.image1} />
                    </div>


                    <p>
                        Há muitos anos ouvimos falar da degradação ambiental, do excesso de poluição na natureza causado pelo mau comportamento dos homens, do mundo consumista. Isso acontece em razão da pouca conscientização que temos de que é fundamental preservar a natureza para continuarmos recebendo tudo que ela nos oferece de melhor, a começar pelo ar que respiramos.

                        Preservar o meio ambiente é um ato importante não só para a humanidade, mas para todos os seres que habitam a Terra. Afinal, é nele que estão os recursos naturais necessários para a sua sobrevivência, como água, alimentos e matérias-primas. Sem esses recursos, todas as formas de vida do planeta poderão acabar.
                    </p>
                    <br />
                    <hr />
                </section>

            </div>
        </>
    )

}